/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'base/components/standalone/ContentLock/theme';

export const ContentLockTheme = theme;
